$(document).ready( function() {
    
    let gapForBanner = 5,
        bannerBottomPropInitial = -5;

    let getHeight = function(elem) {
        return Math.max(
            elem.scrollHeight,
            elem.offsetHeight,
            elem.clientHeight
        );
    };

    let bannerEl = document.querySelector('.banner'),
        footerEl = document.querySelector('.footer'),
        footerHeight = getHeight(footerEl);

    footerEl.style.marginTop = (getHeight(bannerEl) + gapForBanner * 2) + 'px';

    $(document).on('scroll', function(e) {
        let scrollHeight = scrollHeight = Math.max(
                getHeight(document.body), getHeight(document.documentElement)
            ),
            windowHeight = window.innerHeight ? window.innerHeight : Math.max(
                document.body.clientHeight, document.documentElement.clientHeight
            ),
            scrollTop = windowHeight + window.pageYOffset,
            maxAllowedScrollTop = scrollHeight - footerHeight - gapForBanner;
            
        let bannerBottomProp = bannerBottomPropInitial;
        if (scrollTop > maxAllowedScrollTop) {
            bannerBottomProp = scrollTop - maxAllowedScrollTop;
        }

        bannerEl.style.bottom = bannerBottomProp + 'px';
    })
})